export enum UserRole {
    ADMIN = 'admin',
    CLIENT = 'client'
}

export enum UserStatus {
    PENDING = 'pending',
    APPROVED = 'approved',
    BLOCKED = 'blocked'
}

export interface User {
    id: number;
    email: string;
    first_name: string;
    last_name: string;
    role: UserRole;
    status: UserStatus;
    ecwid_customer_id?: number;
    created_at: string;
}

export interface UserCreate {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
}

export interface UserUpdate {
    first_name?: string;
    last_name?: string;
    email?: string;
}

export interface UserAdminUpdate extends UserUpdate {
    role?: UserRole;
    status?: UserStatus;
    ecwid_customer_id?: number;
}

export interface Address {
    id: number;
    user_id: number;
    name: string;
    street: string;
    city: string;
    country_code: string;
    postal_code: string;
    state_or_province_code?: string;
    phone?: string;
    email?: string;
    is_default: boolean;
    delivery_notes?: string;
    created_at: string;
}

export interface AddressCreate {
    name: string;
    street: string;
    city: string;
    country_code: string;
    postal_code: string;
    state_or_province_code?: string;
    phone?: string;
    email?: string;
    is_default?: boolean;
    delivery_notes?: string;
}

export interface AddressUpdate {
    name?: string;
    street?: string;
    city?: string;
    country_code?: string;
    postal_code?: string;
    state_or_province_code?: string;
    phone?: string;
    email?: string;
    is_default?: boolean;
    delivery_notes?: string;
} 